import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { sendVerificationEmail } from '../../../services/email-verification/actions';

import { isTokenExpired } from '../../../services/authentication/utils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { EmailInputFieldComponent, FormComponent, LegendFieldComponent } from '../../form';

export class EmailValidationResendPage extends React.Component {
    componentWillMount() {
        this.checkAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);
        }
    }

    isMemberAuthenticated = () => !isTokenExpired(this.props.token) && this.props.isAuthenticated;

    checkAuthentication({ history }) {
        if (this.isMemberAuthenticated()) {
            new Promise((resolve, reject) => {
                history.push(PATH.HOME_PATH);
                resolve();
            });
        }
    }

    submit = data => {
        const { sendVerificationEmail } = this.props;

        sendVerificationEmail(data);
    };

    render() {
        const { i18n, requestSubmit, successSubmit, errorSubmit, errorMessage } = this.props;

        return (
            <main id="p-validation-email-resend" className="conteneur conteneur-mobile">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.EMAIL_VALIDATION_RESEND_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.EMAIL_VALIDATION_RESEND_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>

                <p>{i18n.TEXT1}</p>

                <FormComponent
                    form="email-verification-resend-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    initialValues={{}}
                    className="email-verification-resend-form"
                    submitText={i18n.CONFIRM}>
                    <EmailInputFieldComponent
                        name="email"
                        label={i18n.EMAIL}
                        placeholder={i18n.PLACEHOLDER_EMAIL}
                        classNameInputContainer="one-half mr50"
                        isRequired
                    />
                    <React.Fragment>
                        {errorMessage && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                        {successSubmit && !requestSubmit && !errorMessage && (
                            <SuccessInfoComponent>
                                <p>{i18n.SUBMIT_SUCCEEDED}</p>
                            </SuccessInfoComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EMAIL_VALIDATION_RESEND,
        token: state.authentication.token,
        isAuthenticated: state.authentication.isAuthenticated,
        requestSubmit: state.email_verification.fetching || false,
        successSubmit: state.email_verification.success,
        errorMessage: state.email_verification.error || '',
        errorSubmit: !isEmpty(state.email_verification.error)
    };
};

const mapDispatchToProps = {
    sendVerificationEmail
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(EmailValidationResendPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/email-validation-resend/EmailValidationResendPage.js